import React from "react";
import { Link } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";
import CancelButton from "presentation/components/buttons/cancel";

import EvaluationResultLabelTerms from 'presentation/pages/evaluation-result-labels/elements/evaluation-result-label-terms';

import { handleChange } from "presentation/utils/functions/generic";

import { handleSubmit } from 'presentation/pages/evaluation-result-labels/functions/evaluation-result-labels';

class EvaluationResultLabelForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            localLoading: false,
            localError: false,
            message: ''
        }
    }


    render() {

        var { localLoading, localError, message } = this.state;
        var { loading, form, component } = this.props;

        return (
            <>
                {loading === true || localLoading === true && <PageLoadingIndicator loadingText={"Carregando informações..."} />}
                {(localLoading === false && localError === true) && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
                {
                    loading === false && localLoading === false && (

                        <Form className="mb-5">
                            <h5>Informações do rótulo de resultado de avaliação</h5>
                            <div className="form">
                                <Form.Label htmlFor="name">Nome</Form.Label>
                                <Form.Control
                                    type="text"
                                    id="name"
                                    name="name"
                                    defaultValue={form.name}
                                    onChange={(e) => handleChange(e, component)}
                                    aria-describedby="nameHelpBlock"
                                />
                                <Form.Text id="nameHelpBlock" muted>
                                    Informe o nome desse rótulo
                                </Form.Text>
                            </div>
                            <div className="mt-3">
                                <EvaluationResultLabelTerms component={component} />
                            </div>
                            <div className="mt-3">
                                <CancelButton
                                    containerProps={{
                                        as: Link,
                                        to: `/rotulos-resultado-avaliacao`
                                    }}
                                />
                                <Button disabled={loading || localError} variant="success" className="float-end" onClick={() => handleSubmit(component)}>Salvar</Button>
                            </div>
                        </Form>
                    )
                }
            </>
        );
    };
}

export default EvaluationResultLabelForm;